<template>
  <div class="list__action__item--content">
    <div class="flex-row flex__between">
        <p class="name margin-0">
        {{ action.creatorName }}
        </p>
      <div class="time font-size__small">
        <i class="fal fa-clock"></i>
        {{ action.createTime | convertToLabelFilter }}
      </div>
    </div>
    <div>
      <p
        :class="[
          'action-type flex-row flex__left inline-flex',
          classColorByActionName()
        ]"
      >
        <i :class="['font-size__small', classIconByActionName()]"></i>
        <span class="font-size__small no_wrap">
          &nbsp;{{ filterActionNameToContent() }}
        </span>
      </p>

      <el-tooltip :content="getUpdatorInfo()" placement="top" effect="dark">
        <span>
          <span class="highlight--name clickable tt-1">
            {{ receiveAgency.name }}
          </span>
        </span>
      </el-tooltip>

      <div
        v-if="action.data.comment"
        class="content__message--text content__message--item"
      >
        <el-input
          v-if="action.data.comment"
          type="textarea"
          resize="none"
          ref="inputComment"
          autosize
          v-model.trim="action.data.comment"
          disabled
          class="input-display__comment style-fullWidth input-none__border bg__transparent"
        ></el-input>
  </div>
    </div>
  </div>
</template>

<script>
  import convertToLabelFilter from "../../filters/convertToLabelFilter";
  import PopoverWord2 from "../common/popover-word-2";
  import constants from "../../constants";

  export default {
    name: "history-status-tltvb",
    components: {PopoverWord2},
    props: ["action","actionType"],
    filters: {
      convertToLabelFilter
    },
    data() {
      return {
        objectType:null,
        receiveAgency: null,
        updator: null
      };
    },
    created() {
      this.action && this.initData();

    },
    methods: {
      filterActionNameToContent(){
        switch(this.action.actionName) {
          case constants.ACTION_LOG_ACTION_NAME.DA_DEN:{
            return "Văn bản đã được lấy về";
          }
          case constants.ACTION_LOG_ACTION_NAME.DA_NHAN: {
            return "Văn bản đã được nhận";
          }
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN:{
            return "Văn bản đã bị từ chối tiếp nhận";
          }
          case constants.ACTION_LOG_ACTION_NAME.PHAN_CONG:{
            return "Văn bản đã được phân công xử lý";
          }
          case constants.ACTION_LOG_ACTION_NAME.DANG_XU_LY:{
            return "Văn bản đang được xử lý";
          }
          case constants.ACTION_LOG_ACTION_NAME.HOAN_THANH:{
            return "Văn bản đã được hoàn thành";
          }
          case constants.ACTION_LOG_ACTION_NAME.DONG_Y:  {
            return "Văn bản đã được đồng ý thu hồi";
          }
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI:{
            return "Văn bản đã bị từ chối thu hồi";
          }
          case constants.ACTION_LOG_ACTION_NAME.THUHOI:{
            return "Văn bản đã được gửi yêu cầu thu hồi";
          }
          case constants.ACTION_LOG_ACTION_NAME.HE_THONG_BAN_HANH:{
            return "Văn bản được ban hành từ trục";
          }
          case constants.ACTION_LOG_ACTION_NAME.TRA_LAI:{
            return "Đồng ý trả lại văn bản";
          }
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI_TRA_LAI:{
            return "Văn bản bị từ chối trả lại";
          }
          case constants.ACTION_LOG_ACTION_NAME.GUI_YEU_CAU_THUHOI_BANHANH:{
            return "Văn bản đã gửi yêu cầu thu hồi";
          }
          default :{
            return "Hành động chưa được xác nhận";
          }
        }
      },
      initData() {
        this.objectType=this.action.data.objectType;
        let dataJson = this.action.dataJson;
        this.receiveAgency = dataJson.receiveAgency;
        this.updator = dataJson.updator;
      },

      classIconByActionName() {
        switch (this.action.actionName) {
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN:
            return "fas fa-ban";
          default:
            return "fal fa-check-circle";
    }
      },

      classColorByActionName() {
        switch (this.action.actionName) {
          case constants.ACTION_LOG_ACTION_NAME.TU_CHOI_TIEP_NHAN:
            return "color__red";
          default:
            return "color__blue";
        }
      },

      getUpdatorInfo() {
        return this.updator
          ? `${this.updator.staff} (${this.updator.department} - ${this.updator
            .mobile || ""} - ${this.updator.email || ""})`
          : `${this.receiveAgency.name} (${this.receiveAgency.code} - ${
            this.receiveAgency.mail
          })`;
      }
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-in/history-status-tltvb.vue